import React, { useState, useEffect } from 'react';
import Sidebar from './Sidebar';
import './structure.css'; // Import your CSS file
import * as Icon from 'react-bootstrap-icons';
import axios from 'axios';

const ITEMS_PER_PAGE = 10;

const Inventory = () => {
  const [toggleValue, setToggleValue] = useState(false);
  const [userDetails, setUserDetails] = useState([]); // For user details
  const [productDetails, setProductDetails] = useState([]); // For product details
  const [orderDetails, setOrderDetails] = useState([]); // For order details
  const [activeSection, setActiveSection] = useState('');
  const [currentUserPage, setCurrentUserPage] = useState(1);
  const [currentProductPage, setCurrentProductPage] = useState(1);
  const [currentOrderPage, setCurrentOrderPage] = useState(1);
  const [searchTerm, setSearchTerm] = useState('');
  const [filteredUserDetails, setFilteredUserDetails] = useState([]);
  const [showUsers, setShowUsers] = useState(false);
  const [showProducts, setShowProducts] = useState(false);
  const [showOrders, setShowOrders] = useState(false);


  useEffect(() => {
    fetchUserDetails();
  }, []); // Fetch data only once on component mount

  const authtoken = localStorage.getItem('token');
  const token = `Bearer ${authtoken}`;

  const fetchUserDetails = async () => {
    try {
      const response = await axios.get(`${process.env.REACT_APP_API_URL}order/admin-details`, {
        headers: {
          Authorization: token,
          'Content-Type': 'application/json',
        },
      });
      setUserDetails(response.data.userDetails || []);
      setProductDetails(response.data.productDetails || []);
      setOrderDetails(response.data.orderDetails || []);
      setFilteredUserDetails(response.data.userDetails || []);
    } catch (error) {
      console.error('Error:', error);
    }
  };

  const handleButtonClick = (section) => {
    setActiveSection(section);
    setCurrentUserPage(1); // Reset user page
    setCurrentProductPage(1); // Reset product page
    setCurrentOrderPage(1); // Reset order page
    if (section === 'users') {
      setShowUsers(!showUsers);
    } else if (section === 'products') {
      setShowProducts(!showProducts);
    } else if (section === 'orders') {
      setShowOrders(!showOrders);
    }

  };

  // Pagination for user details
  const userPaginatedData = () => {
    const startIndex = (currentUserPage - 1) * ITEMS_PER_PAGE;
    return userDetails.slice(startIndex, startIndex + ITEMS_PER_PAGE);
  };

  const totalUserPages = Math.ceil(userDetails.length / ITEMS_PER_PAGE) || 1;

  // Pagination for product details
  const productPaginatedData = () => {
    const startIndex = (currentProductPage - 1) * ITEMS_PER_PAGE;
    return productDetails.slice(startIndex, startIndex + ITEMS_PER_PAGE);
  };

  const totalProductPages = Math.ceil(productDetails.length / ITEMS_PER_PAGE) || 1;

  // Pagination for order details
  const orderPaginatedData = () => {
    const startIndex = (currentOrderPage - 1) * ITEMS_PER_PAGE;
    return orderDetails.slice(startIndex, startIndex + ITEMS_PER_PAGE);
  };

  const totalOrderPages = Math.ceil(orderDetails.length / ITEMS_PER_PAGE) || 1;

  const nextUserPage = () => {
    if (currentUserPage < totalUserPages) {
      setCurrentUserPage(prevPage => prevPage + 1);
    }
  };

  const prevUserPage = () => {
    if (currentUserPage > 1) {
      setCurrentUserPage(prevPage => prevPage - 1);
    }
  };


  const nextProductPage = () => {
    if (currentProductPage < totalProductPages) {
      setCurrentProductPage(prevPage => prevPage + 1);
    }
  };

  const prevProductPage = () => {
    if (currentProductPage > 1) {
      setCurrentProductPage(prevPage => prevPage - 1);
    }
  };

  const nextOrderPage = () => {
    if (currentOrderPage < totalOrderPages) {
      setCurrentOrderPage(prevPage => prevPage + 1);
    }
  };

  const prevOrderPage = () => {
    if (currentOrderPage > 1) {
      setCurrentOrderPage(prevPage => prevPage - 1);
    }
  };

  return (
    <div style={{ padding: 0, margin: 0, backgroundColor: '#f8f9fa', height: '100vh' }}>
      <div style={{ display: 'flex', margin: 0, padding: 0 }}>
        <div style={{ width: '16.67%', padding: 0 }}>
          <Sidebar toggleSidebar={toggleValue} setToggleValue={setToggleValue} />
        </div>
        <div style={{ width: '83.33%', padding: 0 }}>
          <Icon.ArrowRight
            onClick={() => setToggleValue(true)}
            style={{ margin: '20px', cursor: 'pointer' }}
            color='black'
            size={30}
          />
          <div style={{ padding: '20px' }}>
            <h3>Inventory Report</h3>
            <div style={{ marginBottom: '20px' }}>
              <button
                onClick={() => handleButtonClick('users')}
                style={{ marginRight: '10px', padding: '10px 20px', backgroundColor: '#343a40', color: 'white', border: 'none', borderRadius: '5px', cursor: 'pointer' }}
              >
                {showUsers ? "Hide Total Users" : "Show Total Users"}
              </button>
              <button
                onClick={() => handleButtonClick('products')}
                style={{ marginRight: '10px', padding: '10px 20px', backgroundColor: '#343a40', color: 'white', border: 'none', borderRadius: '5px', cursor: 'pointer' }}
              >
                {showProducts ? "Hide Total Products" : "Show Total Products"}


              </button>
              <button
                onClick={() => handleButtonClick('orders')}
                style={{ padding: '10px 20px', backgroundColor: '#343a40', color: 'white', border: 'none', borderRadius: '5px', cursor: 'pointer' }}
              >

                {showOrders ? "Hide  Total Orders" : "Show  Total Orders"}


              </button>
            </div>



            {showUsers && activeSection === 'users' && (
              <div>
                <h5>User Details</h5>
                <div style={{ marginBottom: '10px' }}>
                </div>
                <div style={{ overflowX: 'auto' }}>
                  <table style={{ width: '100%', borderCollapse: 'collapse', border: '1px solid #dee2e6' }}>
                    <thead>
                      <tr>
                        <th style={{ border: '1px solid #dee2e6', padding: '10px', backgroundColor: '#343a40', color: 'white' }}>ID</th>
                        <th style={{ border: '1px solid #dee2e6', padding: '10px', backgroundColor: '#343a40', color: 'white' }}>Name</th>
                        <th style={{ border: '1px solid #dee2e6', padding: '10px', backgroundColor: '#343a40', color: 'white' }}>Email</th>
                        <th style={{ border: '1px solid #dee2e6', padding: '10px', backgroundColor: '#343a40', color: 'white' }}>Commission Balance</th>
                      </tr>
                    </thead>
                    <tbody>
                      {userPaginatedData().map(user => (
                        <tr key={user.id}>
                          <td style={{ border: '1px solid #dee2e6', padding: '10px' }}>{user.id}</td>
                          <td style={{ border: '1px solid #dee2e6', padding: '10px' }}>{user.name}</td>
                          <td style={{ border: '1px solid #dee2e6', padding: '10px' }}>{user.email}</td>
                          <td style={{ border: '1px solid #dee2e6', padding: '10px' }}>{user.commissionBalance}</td>
                        </tr>
                      ))}
                    </tbody>
                  </table>

                  {/* Pagination Controls for Products */}
                  <div style={{ marginTop: "10px" }}>
                    <button onClick={prevUserPage} disabled={currentUserPage === 1}>Previous</button>
                    <span> Page {currentUserPage} of {totalUserPages} </span>
                    <button onClick={nextUserPage} disabled={currentUserPage === totalUserPages}>Next</button>
                  </div>
                </div>
              </div>

            )}

            {showProducts && activeSection === 'products' && (
              <div>
                <h5>Product Details</h5>
                <table>
                  <thead>
                    <tr>
                      <th style={{ border: '1px solid #dee2e6', padding: '10px', backgroundColor: '#343a40', color: 'white' }}>Product ID</th>
                      <th style={{ border: '1px solid #dee2e6', padding: '10px', backgroundColor: '#343a40', color: 'white' }}>Product Name</th>
                      <th style={{ border: '1px solid #dee2e6', padding: '10px', backgroundColor: '#343a40', color: 'white' }}>SKU</th>
                      <th style={{ border: '1px solid #dee2e6', padding: '10px', backgroundColor: '#343a40', color: 'white' }}>Stock Quantity</th>
                      <th style={{ border: '1px solid #dee2e6', padding: '10px', backgroundColor: '#343a40', color: 'white' }}>Price</th>
                      <th style={{ border: '1px solid #dee2e6', padding: '10px', backgroundColor: '#343a40', color: 'white' }}>Category</th>
                      <th style={{ border: '1px solid #dee2e6', padding: '10px', backgroundColor: '#343a40', color: 'white' }}>Subcategory</th>
                    </tr>
                  </thead>
                  <tbody>
                    {productPaginatedData().map(product => (
                      <tr key={product.productId}>
                        <td style={{ border: '1px solid #dee2e6', padding: '10px' }}>{product.productId}</td>
                        <td style={{ border: '1px solid #dee2e6', padding: '10px' }}>{product.productName}</td>
                        <td style={{ border: '1px solid #dee2e6', padding: '10px' }}>{product.sku}</td>
                        <td style={{ border: '1px solid #dee2e6', padding: '10px' }}>{product.stockQuantity}</td>
                        <td style={{ border: '1px solid #dee2e6', padding: '10px' }}>{product.price}</td>
                        <td style={{ border: '1px solid #dee2e6', padding: '10px' }}>{product.categoryName}</td>
                        <td style={{ border: '1px solid #dee2e6', padding: '10px' }}>{product.subcategoryName}</td>
                      </tr>
                    ))}
                  </tbody>
                </table>

                {/* Pagination Controls for Products */}
                <div style={{ marginTop: "10px" }}>
                  <button onClick={prevProductPage} disabled={currentProductPage === 1}>Previous</button>
                  <span> Page {currentProductPage} of {totalProductPages} </span>
                  <button onClick={nextProductPage} disabled={currentProductPage === totalProductPages}>Next</button>
                </div>
              </div>
            )}

            {showOrders && activeSection === 'orders' && (
              <div>
                <h5>Order Details</h5>
                <table>
                  <thead>
                    <tr>
                      <th style={{ border: '1px solid #dee2e6', padding: '10px', backgroundColor: '#343a40', color: 'white' }}>Order ID</th>
                      <th style={{ border: '1px solid #dee2e6', padding: '10px', backgroundColor: '#343a40', color: 'white' }}>Order Number</th>
                      <th style={{ border: '1px solid #dee2e6', padding: '10px', backgroundColor: '#343a40', color: 'white' }}>Total Amount</th>
                      <th style={{ border: '1px solid #dee2e6', padding: '10px', backgroundColor: '#343a40', color: 'white' }}>Payment Mode</th>
                      <th style={{ border: '1px solid #dee2e6', padding: '10px', backgroundColor: '#343a40', color: 'white' }}>Order Date</th>
                    </tr>
                  </thead>
                  <tbody>
                    {orderPaginatedData().map(order => (
                      <tr key={order.orderId}>
                        <td style={{ border: '1px solid #dee2e6', padding: '10px' }}>{order.orderId}</td>
                        <td style={{ border: '1px solid #dee2e6', padding: '10px' }}>{order.orderNumber}</td>
                        <td style={{ border: '1px solid #dee2e6', padding: '10px' }}>{order.totalAmount}</td>
                        <td style={{ border: '1px solid #dee2e6', padding: '10px' }}>{order.paymentmethod}</td>
                        <td style={{ border: '1px solid #dee2e6', padding: '10px' }}> {new Date(order.orderDate).toLocaleString()}</td>
                      </tr>
                    ))}
                  </tbody>
                </table>

                {/* Pagination Controls for Orders */}
                <div style={{ marginTop: "10px" }}>
                  <button onClick={prevOrderPage} disabled={currentOrderPage === 1}>Previous</button>
                  <span> Page {currentOrderPage} of {totalOrderPages} </span>
                  <button onClick={nextOrderPage} disabled={currentOrderPage === totalOrderPages}>Next</button>
                </div>
              </div>
            )}
          </div>
        </div>
      </div>
    </div>

  );
};

export default Inventory;









